import { baseURL } from "./shared/baseurl";
const ɵ0 = baseURL;
export class AppModule {
}
export { ɵ0 };
